import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon"]
  static values = { url: String }

  async sync() {
    if (this.hasIconTarget) this.iconTarget.classList.add("fa-spin")
    this.element.disabled = true

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          "Accept": "application/json"
        }
      })

      if (response.ok) {
        window.dispatchEvent(new CustomEvent("toast:show", {
          detail: { message: "Sync started. Your data will update shortly.", type: "success" }
        }))
      } else {
        window.dispatchEvent(new CustomEvent("toast:show", {
          detail: { message: "Could not start sync. Check your IB credentials.", type: "error" }
        }))
      }
    } catch {
      window.dispatchEvent(new CustomEvent("toast:show", {
        detail: { message: "Network error. Please try again.", type: "error" }
      }))
    } finally {
      if (this.hasIconTarget) this.iconTarget.classList.remove("fa-spin")
      this.element.disabled = false
    }
  }
}
